import React from 'react'

const LeftArrow = props => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30.000000pt" height="30.000000pt" viewBox="0 0 203.000000 203.000000" preserveAspectRatio="xMidYMid meet" {...props}>
    <g transform="translate(0.000000,203.000000) scale(0.100000,-0.100000)" fill="#909090" stroke="none">
      <path d="M208 1192 c-108 -92 -196 -171 -196 -177 0 -10 391 -345 402 -345 4 0 6 36 6 80 l0 80 805 0 805 0 0 185 0 185 -805 0 -805 0 0 80 c0 44 -3 80 -7 79 -5 0 -96 -75 -205 -167z"/>
    </g>
  </svg>
)

export default LeftArrow;
